import RefreshIcon from '@/assets/icons/Refresh';
import SelectControl from '@/components/controls/select-control';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { MONTHS_LIST } from '@/features/agro-technical-events/constants/month';
import { cn } from '@/lib/utils';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMasterApprenticesFilter } from '../../hooks';

export const MasterApprenticesFilter = () => {
  const { t } = useTranslation();
  const { form, handleSearch, handleClear } = useMasterApprenticesFilter();

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(handleSearch)}
        className={cn('w-full my-6 md:w-1/3')}
      >
        <div className="flex flex-col sm:flex-row items-stretch sm:items-end gap-2">
          <div className="flex-1 min-w-0">
            <SelectControl
              control={form.control}
              name="month"
              placeholder="Oy"
              options={MONTHS_LIST.map((month) => ({
                value: month.value,
                label: t(month.label),
              }))}
              className="w-full"
              notRequired
            />
          </div>
          <div className="flex gap-2">
            <Button
              type="submit"
              className="px-3 bg-green-600 hover:bg-green-700 text-white"
            >
              <Search className="size-4" />
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={handleClear}
              className="px-3"
            >
              <RefreshIcon />
            </Button>
          </div>
        </div>
      </form>
    </Form>
  );
};
